/** Shared form option lists — keep in sync with docxs-mobile generate-document.tsx */

export const PURPOSE_OPTIONS = [
  { value: 'work', label: 'Work' },
  { value: 'study', label: 'Study' },
];

export const TONE_OPTIONS = [
  { value: 'formal', label: 'Formal' },
  { value: 'professional', label: 'Professional' },
  { value: 'enthusiastic', label: 'Enthusiastic' },
  { value: 'academic', label: 'Academic' },
];

export const PROGRAM_TYPE_OPTIONS = [
  { value: 'Bachelor', label: 'Bachelor' },
  { value: 'Masters', label: 'Masters' },
  { value: 'MBA', label: 'MBA' },
  { value: 'MPhil', label: 'MPhil' },
  { value: 'PhD', label: 'PhD' },
  { value: 'Doctorate', label: 'Doctorate' },
  { value: 'Postgraduate Diploma', label: 'Postgraduate Diploma' },
  { value: 'Certificate', label: 'Certificate' },
];

export const CONTRACT_TYPE_OPTIONS = [
  { value: 'Employment Agreement', label: 'Employment Agreement' },
  { value: 'Service Agreement', label: 'Service Agreement' },
  { value: 'Non-Disclosure Agreement (NDA)', label: 'Non-Disclosure Agreement (NDA)' },
  { value: 'Consultancy Agreement', label: 'Consultancy Agreement' },
  { value: 'Sales Agreement', label: 'Sales Agreement' },
  { value: 'Lease Tenancy Agreement', label: 'Lease / Tenancy Agreement' },
  { value: 'Partnership Agreement', label: 'Partnership Agreement' },
  { value: 'Independent Contractor Agreement', label: 'Independent Contractor Agreement' },
  { value: 'Loan Agreement', label: 'Loan Agreement' },
  { value: 'Licensing Agreement', label: 'Licensing Agreement' },
  { value: 'Joint Venture Agreement', label: 'Joint Venture Agreement' },
  { value: 'Memorandum of Understanding (MOU)', label: 'Memorandum of Understanding (MOU)' },
  { value: 'Supply Agreement', label: 'Supply Agreement' },
  { value: 'Franchise Agreement', label: 'Franchise Agreement' },
];

export const MONTH_OPTIONS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

export const DEGREE_OPTIONS = [
  { value: 'SSCE / WAEC', label: 'SSCE / WAEC' },
  { value: 'OND', label: 'OND' },
  { value: 'HND', label: 'HND' },
  { value: 'Diploma', label: 'Diploma' },
  { value: 'B.Sc', label: 'B.Sc' },
  { value: 'B.A', label: 'B.A' },
  { value: 'B.Eng', label: 'B.Eng' },
  { value: 'B.Ed', label: 'B.Ed' },
  { value: 'B.Tech', label: 'B.Tech' },
  { value: 'LL.B', label: 'LL.B' },
  { value: 'M.Sc', label: 'M.Sc' },
  { value: 'M.A', label: 'M.A' },
  { value: 'MBA', label: 'MBA' },
  { value: 'M.Eng', label: 'M.Eng' },
  { value: 'PhD', label: 'PhD' },
  { value: 'Professional Certificate', label: 'Professional Certificate' },
];
